import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { groupKitSkillExpertControllerGetSkillExperts } from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

export const useSkillExpertsData = (
  groupUuid: string | null,
  kitUuid: string | null,
  skillUuid: string | null,
) => {
  const { data: expertUuids } = useQuery({
    enabled: useIsApiReady() && !!groupUuid && !!kitUuid && !!skillUuid,
    queryKey: queryKeys.skillExperts(groupUuid!, kitUuid!, skillUuid!),
    initialData: [],
    queryFn: async () => {
      const response = await groupKitSkillExpertControllerGetSkillExperts({
        path: {
          groupUuid: groupUuid!,
          kitUuid: kitUuid!,
          skillUuid: skillUuid!,
        },
      });
      return response.data?.data ?? [];
    },
  });

  return {
    expertUuids,
  };
};
